import { render, staticRenderFns } from "./AdminAskStock.vue?vue&type=template&id=46ad5e24&scoped=true&"
import script from "./AdminAskStock.vue?vue&type=script&lang=js&"
export * from "./AdminAskStock.vue?vue&type=script&lang=js&"
import style0 from "./AdminAskStock.vue?vue&type=style&index=0&id=46ad5e24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ad5e24",
  null
  
)

export default component.exports